import { render } from "./view.vue?vue&type=template&id=6dc01b14&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=6dc01b14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dc01b14"

export default script